export const INJECTION_TYPE = "__injection_type__";
